export default __webpack_public_path__ + "static/media/1-4-2.fe2b9a5e.webp";